<template>
	<div>
		<el-drawer :modal="false" title="Net Income" :visible.sync="drawerViewNetIncomeDetails"
			class="drawer-view-net-income-details" size="45%">
			<b-container>
				<b-row class="mb-4 align-items-center">
					<b-col>
						<span>Total</span>
						<div class="d-flex align-items-center">
							<h2 class="mb-0 mr-3">RM {{ parseFloat(_gHlp.getValue(activeCustomer,'incomes.main.net_income',0)).toLocaleString(undefined, {minimumFractionDigits: 2 })}}</h2>
							<el-button type="text" @click="toggleDetailsModal">View Details</el-button>
						</div>
					</b-col>
					<!-- <b-col>
                        <b-button variant="primary" class="float-right">View Commitment</b-button>
                              </b-col> -->
				</b-row>

				<ValidationObserver v-slot="{ invalid }" ref="observer">
					<b-form role="form" class="mt-4">
						<b-row>
							<b-col cols="8">
								<b-form-group label="I am">
									<el-select v-model="form.income_type_id" placeholder="Select" change="selectIncome">
										<el-option :label="income_type.name" :value="income_type.income_type_id"
											v-for="income_type in tables.income_types" :key="income_type.income_type_id"></el-option>
									</el-select>
								</b-form-group>
							</b-col>

							<b-col cols="8">
								<b-form-group label="I earn" v-if="show.iearn">
									<el-select v-model="form.income_earn_type_id" placeholder="Select" change="selectIncome">
										<el-option :label="income_earn_type.name" :value="income_earn_type.income_earn_type_id"
											v-for="income_earn_type in tables.income_earn_types"
											:key="income_earn_type.income_earn_type_id"></el-option>
									</el-select>
								</b-form-group>
							</b-col>

							<b-col cols="8" v-if="show.salary">
								<b-form-group label="Salary (Monthly)">
									<CurrencyInput v-model="form.salary"
										:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
								</b-form-group>
							</b-col>

							<b-col cols="8" v-if="show.fixed_allowance">
								<b-form-group label="Fixed Allowance">
									<el-checkbox v-model="form.epf_excluded_fa" class="mb-3">Exclude EPF</el-checkbox>
									<CurrencyInput v-model="form.fixed_allowance"
										:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
								</b-form-group>
							</b-col>

							<!-- <b-col cols="8" class="mb-3">
                                <b-button block variant="primary" class="w-50" @click.prevent="updateMainIncome()" :disabled="invalid">Save</b-button>
                                      </b-col> -->

							<!-- Variable Income -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.var_income" :disabled="disableVarIncome" name="checkbox-toggle"
										class="py-3">
										<h3>Variable Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.var_income">
										<VariableIncome :customer.sync="activeCustomer" :show_contribution.sync="show_contribution"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Commission -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.commission" :disabled="disableCommission" name="checkbox-toggle"
										class="py-3">
										<h3>Commission</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.commission">
										<Commission :customer.sync="activeCustomer" @income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Business Income -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="form.bizIncome" :disabled="disableBizIncome" name="checkbox-toggle"
										class="py-3">
										<h3>Business Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="form.bizIncome">
										<BusinessIncome :customer.sync="activeCustomer" :tables="tables"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Bonus -->
							<b-col cols="12">
								<div class="accordion bonus-accordion">
									<b-form-checkbox v-model="bonusChecked" :disabled="disableBonus" name="checkbox-toggle" class="py-3">
										<h3>Bonus</h3>
									</b-form-checkbox>
									<b-collapse v-model="bonusChecked">
										<BonusIncome :customer.sync="activeCustomer" @income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Rental Income -->
							<b-col cols="12">
								<div class="accordion rental-income">
									<b-form-checkbox v-model="rentalChecked" name="checkbox-toggle" class="py-3">
										<h3>Monthly Rental Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="rentalChecked">
										<RentalIncome :customer.sync="activeCustomer" :tables="tables"
											@income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Monthly Other Income -->
							<b-col cols="12">
								<div class="accordion other-income">
									<b-form-checkbox v-model="otherChecked" name="checkbox-toggle" class="py-3">
										<h3>Monthly Other Income</h3>
									</b-form-checkbox>
									<b-collapse v-model="otherChecked">
										<OtherIncome :customer.sync="activeCustomer" @income-data-collected="collectedIncomeData" />
									</b-collapse>
								</div>
							</b-col>

							<!-- Deduction -->
							<b-col cols="12">
                  <div class="accordion deduction">
									<b-form-checkbox v-model="deductionChecked" :disabled="disabledDeduction" name="checkbox-toggle"
										class="py-3">
                          <h3>Deduction</h3>
                      </b-form-checkbox>
                      <b-collapse v-model="deductionChecked">
										<TaxDeduction :customer.sync="activeCustomer" @income-data-collected="collectedIncomeData" />
                      </b-collapse>
                  </div>
							</b-col>
						</b-row>
						<b-row class="mt-1 pt-4 pb-5 d-flex justify-content-center">
							<b-col cols="4">
								<el-button class="bg-primary text-white w-100" @click.prevent="updateAll()"
									:loading="is_loading">Save</el-button>
							</b-col>
						</b-row>
					</b-form>
				</ValidationObserver>
			</b-container>
		</el-drawer>
		<!-- Modal View  -->
		<modal :show.sync="modals.view_income_details" modalClasses="drawer-view-net-income-modal">
			<h6 slot="header" class="modal-title">Net Income Details</h6>
			<table-net-income-details :customer.sync="activeCustomer"></table-net-income-details>
			<div slot="footer"></div>
		</modal>
	</div>
</template>
<script>
import { Drawer, Button, RadioGroup, RadioButton, Checkbox, Collapse, CollapseItem, Form, FormItem, Select, Option } from 'element-ui'
import BonusIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/BonusIncome'
import RentalIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/RentalIncome'
import OtherIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/OtherIncome'
import VariableIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/VariableIncome'
import Commission from '@/views/CustomerProfile/Drawers/DrawerNetIncome/Commission'
import BusinessIncome from '@/views/CustomerProfile/Drawers/DrawerNetIncome/BusinessIncome'
import TaxDeduction from '@/views/CustomerProfile/Drawers/DrawerNetIncome/TaxDeduction'
import TableNetIncomeDetails from '@/views/CustomerProfile/Drawers/DrawerNetIncome/TableNetIncomeDetails'
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';
import { ValidationObserver } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	name: 'drawer-view-net-income-details',
	components: {
		CurrencyInput,
		ValidationObserver,
		[Drawer.name]: Drawer,
		[Button.name]: Button,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
		[Checkbox.name]: Checkbox,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Select.name]: Select,
		[Option.name]: Option,
		VariableIncome,
		Commission,
		BusinessIncome,
		BonusIncome,
		RentalIncome,
		OtherIncome,
		TableNetIncomeDetails,
		TaxDeduction
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer']),
	},
	data() {
		return {
			is_loading: false,
			mainForm: {},
			show_contribution: false,
			drawerViewNetIncomeDetails: false,
			form: {
				income_type_id: '',
				income_earn_type_id: '',
				salary: '',
				fixed_allowance: '',
				var_income: false,
				commission: false,
				bizIncome: false,
				total_rental_income: '',
				total_other_income: '',
				epf_excluded_fa: false
			},
			show: {
				salary: true,
				fixed_allowance: true,
				iearn: false
			},
			bonusChecked: false,
			rentalChecked: false,
			otherChecked: false,
			deductionChecked: false,
			disabledDeduction: true,
			disableVarIncome: true,
			disableCommission: true,
			disableBonus: true,
			disableBizIncome: true,
			tables: {},
			modals: {
				view_income_details: false
			}
		};
	},
	watch: {
		'form.income_earn_type_id': {
			handler: function (newValue) {
				switch (newValue) {
					case 1:
						this.form.var_income = false
						this.disableVarIncome = true;
						this.form.commission = false
						this.disableCommission = true;
						break;
					case 2:
						this.form.var_income = true
						this.disableVarIncome = false;
						this.form.commission = false
						this.disableCommission = true;
						break;
					case 3:
						this.form.var_income = true
						this.disableVarIncome = false;
						this.form.commission = true
						this.disableCommission = false;
						break;
				}
			},
			immediate: true
		},
		'form.income_type_id': {
			handler: function (newValue) {
				switch (newValue) {
					case 1:
						this.show_contribution = false
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableBonus = false;
						this.disabledDeduction = false;
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = true
						if (this.form.income_earn_type_id === 1) {
							this.form.var_income = false
							this.disableVarIncome = true;
							this.form.commission = false
							this.disableCommission = true;
						}
						if (this.form.income_earn_type_id === 2) {
							this.form.var_income = true
							this.disableVarIncome = false;
							this.form.commission = false
							this.disableCommission = true;
						}
						if (this.form.income_earn_type_id === 3) {
							this.form.var_income = true
							this.disableVarIncome = false;
							this.form.commission = true
							this.disableCommission = false;
						}
						break;
					case 2:
						this.show_contribution = false
						this.show.salary = false;
						this.show.fixed_allowance = false;
						this.form.var_income = false;
						this.disableVarIncome = true;
						this.form.commission = false;
						this.disableCommission = true;
						this.disableBonus = true;
						this.disabledDeduction = true
						this.disableBizIncome = false
						this.form.bizIncome = true
						this.show.iearn = false
						break;
					case 3:
						this.show_contribution = true
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableVarIncome = false;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = false
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					case 4:
						this.show_contribution = false
						this.show.salary = false;
						this.show.fixed_allowance = false;
						this.disableVarIncome = true;
						this.form.var_income = false;
						this.disableCommission = false
						this.disableBonus = false;
						this.disabledDeduction = true
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					case 5:
						this.show_contribution = true
						this.show.salary = true;
						this.show.fixed_allowance = true;
						this.disableVarIncome = false;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = false
						this.disableBizIncome = true
						this.form.bizIncome = false
						this.show.iearn = false
						break;
					default:
						this.disableVarIncome = true;
						this.disableCommission = true;
						this.disableBonus = false;
						this.disabledDeduction = true
						this.disableBizIncome = true
						this.show.iearn = false
				}
			},
			immediate: true
		},
	},
	async created() {
		this.getTablesLookup();
		this.$watch(
			() => this.activeCustomer,
			(newVal) => {
				if (newVal) {
					this.rentalChecked = (newVal.incomes?.rental?.length || 0) > 0
					this.bonusChecked = (newVal.incomes?.bonus?.length || 0) > 0
					this.otherChecked = (newVal.incomes?.other?.length || 0) > 0
					this.deductionChecked = (_gHlp.getValue(newVal,'incomes.other_tax_deduction',[]))?.length > 0 || (_gHlp.getValue(newVal,'incomes.main.tax_deduction',[]) > 0)

					if (newVal.incomes?.main) {
						const { income_type_id, income_earn_type_id, monthly_salary, fixed_allowance } = newVal.incomes?.main
						this.form.income_type_id = income_type_id ?? ""
						this.form.income_earn_type_id = income_earn_type_id ?? ""
						this.form.salary = monthly_salary ?? ""
						this.form.fixed_allowance = fixed_allowance ?? ""
					}

					if (this.form.income_type_id === 2) {
						this.form.bizIncome = (newVal.incomes?.business?.length || 0) > 0 || newVal.incomes.main.income_type_id === 2
					}

					this.form.commission = (newVal.incomes?.commission?.length || 0) > 0

					if (![2, 4].includes(this.form.income_type_id)) {
						this.form.var_income = (newVal.incomes?.variable?.length || 0) > 0
					}
				}
			},
			{ immediate: true }
		)
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomerIm2u', 'updateIncomeMain', 'updateIncome']),
		...mapActions(useCommonStore, ['getTables']),
		async getTablesLookup() {
			this.tables = await this.getTables('income_types,income_earn_types,iff_codes');
		},
		collectedIncomeData(newData) {
			this.mainForm = Object.assign(this.mainForm, newData);
		},
		updateAll() {
			this.is_loading = true

			// emit event to collect all data from different components
			gEventBus.$emit('collect-income-data')

			// add main parent data
			this.mainForm = Object.assign(this.mainForm, {
				income_type_id: this.form.income_type_id,
				income_earn_type_id: this.form.income_earn_type_id,
				monthly_salary: this.form.salary,
				fixed_allowance: this.form.fixed_allowance,
				is_ex_epf_fa: this.form.epf_excluded_fa
			});

			this.updateIncome(this.mainForm)
			.then(async (res) => {
				_gNotif.notifySuccess('<b>Net Income: ' + this.activeCustomer.name + '</b> - Successfully Updated.');
				await this.getCustomerIm2u(this.activeCustomer.customer_id);
				this.is_loading = false
			})
			.catch(e => {
				_gNotif.errorFunction(e)
				this.is_loading = false
			})
		},
		updateMainIncome() {
			const data = {
				income_type_id: this.form.income_type_id,
				income_earn_type_id: this.form.income_earn_type_id,
				monthly_salary: this.form.salary,
				fixed_allowance: this.form.fixed_allowance,
				is_ex_epf_fa: this.form.epf_excluded_fa
			}
			this.updateIncomeMain(this.activeCustomer.incomes.main.customer_main_income_id, data)
			.then(async (res) => {
				_gNotif.notifySuccess('<b>Net Income: ' + this.activeCustomer.name + '</b> - Successfully Updated.')
				await this.getCustomerIm2u(this.activeCustomer.customer_id);
			})
			.catch(e => {
				_gNotif.errorFunction(e);
			});
		},
		viewDetails() {
			this.drawerViewNetIncomeDetails = !this.drawerViewNetIncomeDetails;
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		removeOther(item) {
			var index = this.dynamicOther.other.indexOf(item);
			if (index !== 0) {
				this.dynamicOther.other.splice(index, 1);
			}
		},
		addOther() {
			this.dynamicOther.other.push({
				key: Date.now(),
				income_amount: '',
				information: ''
			});
		},
		toggleDetailsModal() {
			this.modals.view_income_details = !this.modals.view_income_details;
		},
		selectIncome() {
			if (this.form.income_type_id === 3) {
				this.form.var_income = true;
			}
		}

	}
}
</script>